import { MatchScores, Shortlist } from "PFTypes";

export type ShortlistWithScores = Omit<Shortlist, "scores"> & {
  scores: MatchScores | null;
};

export type OpenVacancyItem = {
  openVacancy: true;
};

export type SuggestedWmTableItem = ShortlistWithScores | OpenVacancyItem;

export const isOpenVacancyItem = (item: SuggestedWmTableItem): item is OpenVacancyItem =>
  "openVacancy" in item && item.openVacancy;
